import * as React from 'react';
import Campo from './Campo';

interface AsignaturaProps {
    asignaturas: string[];
}
const Asignatura: React.FunctionComponent<AsignaturaProps> = props => {
    const { asignaturas } = props;
    return (
        <span>
            {asignaturas.map((asignatura, indice) => (
                <Campo
                    key={asignatura}
                    etiqueta={indice === 0 ? 'Asignaturas' : undefined}
                    valor={'⁕ ' + asignatura}
                />
            ))}
        </span>
    );
};

export default Asignatura;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/Asignatura.tsx